import { Product } from './../models/billing-letter/Product.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/wrappers/HttpClient';
import { UrlBuilder } from '../models/utils/url-builder.model';
import { ProductSearch } from '../models/ProductSearch.model';
import { columnsTotalWidth } from '@swimlane/ngx-datatable/release/utils';

@Injectable()
export class ProductService {

  constructor(private httpClient: HttpClient) { }

  endPoint: String = "/products";

  async getAllProducts(): Promise<Product[]> {
    let products = new Array<Product>();
    let productsServer = await this.httpClient.get(`${this.endPoint}`);
    for (let p of productsServer) {
      let prod = new Product();
      prod.populate(p);
      products.push(prod);
    }

    return products;
  }

  async getAllItems(): Promise<Product[]> {
    let items = new Array<Product>();
    let itemsServer = await this.httpClient.get(`${this.endPoint}/purchase-items`);
    for (let i of itemsServer) {
      let item = new Product();
      item.populate(i);
      items.push(item);
    }
    return items;
  }

  async getById(id): Promise<Product>{
      var productToEdit = new Product();
      var response = await this.httpClient.get(`${this.endPoint}/${id}`);
      productToEdit.loadToEdit (response);
      return productToEdit;
  }

  async create(product: Product){
    return await this.httpClient.post(this.endPoint, product);
  }

  async update(product: Product){
      return await this.httpClient.update(this.endPoint, product._id, product);
  }

  async searchProduct(productSearch: ProductSearch): Promise<Product[]> {
    const builder = new UrlBuilder([
          { key: "skip", value: productSearch.skip },
          { key: "limit", value: productSearch.limit }
      ]);

      builder.addQueryStringParamsInsideFilter([
          { key: "name", value: productSearch.name }
      ])

      let url = builder.buildUrl(`${this.endPoint}`);

      let response = await this.httpClient.get(url);
      productSearch.totalItems = response.length;
      let productModel = new Array<Product>();
      for (let ps of response){
          var productsSearch = new Product();
          productsSearch.loadSearch(ps)
          productModel.push(productsSearch);
      }

      return productModel;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/product.service.ts